import React from "react";
import ErrorShell, { GoHomeButton } from "./ErrorShell";
export default function SubscriptionExpired() {
  return <ErrorShell code="⏳" title="Subscription expired" message="Your subscription has expired. Please renew your plan to continue using AWebBee GMB Manager." action={<GoHomeButton label="Back to login" />} />;
}
